import React, {useContext } from 'react'
import DataFetch  from '../../Context/DataFetch'
import moment from 'moment';
import Language from '../../Context/Language'

export default function NextMatches() {
  const {HomeNextMatchData} = useContext(DataFetch)
  const {AwayNextMatchData} = useContext(DataFetch)
  const dataLang = useContext(Language)

  const changeBackground=(a) => e => {
    if(e.target.offsetWidth < e.target.scrollWidth) {
      e.target.setAttribute('data-tooltip', a);
    }
    else{
      
    }

  }

  return (
    <div className='NextMatchesContainer'>
        <div className='NextMatchHeader'><div className='NextMatchHeaderText'>{dataLang[sessionStorage.getItem("lang")].NextMatches}</div></div>
        <div className='NextMatchTeamsArea'>
        <div className='HomeTeamNextArea NextBorder'>
          <div className='HomeTeamNextDiv'>
          <div className='HomeNextMatchShow'>
              <div className='HomeNextMatchShowDate'>{dataLang[sessionStorage.getItem("lang")].Date}</div>
              <div className='HomeNextMatchShowMatch'>{dataLang[sessionStorage.getItem("lang")].Match}</div>
              <div className='HomeNextMatchShowTournament'>{dataLang[sessionStorage.getItem("lang")].Tournament}</div>
          </div>

          {
            HomeNextMatchData.length !==0 ?
                           HomeNextMatchData.sort((a,b) => new Date(a.start_Time)    -  new Date(b.start_Time)).map(function(item, i){
                            return   <div key={i} className='HomeTeamMatchLine'>
                            <div className='HomeNextMatchShowDate'>{moment(item.start_Time).format("DD/MM/YY")}</div>
                                <div className='HomeNextMatchShowMatch'>
                                  <div id='teamSelected' className='HomeNextMatchShowMatchHome'>{item.home_Team_Name}</div>
                                  <div className='HomeNextMatchShowMatchSpan'>-</div>
                                  <div className='HomeNextMatchShowMatchAway'>{item.away_Team_Name}</div>
                                </div>
                                <div onMouseOver={changeBackground(item.competitionName)} className="tooltip HomeNextMatchShowTournament" ><div className="BeetweenMatchTextTool">{item.competitionName}</div></div>
                            </div>
                           })
                           :
                           ""
          }

          </div>
        </div>

     <div className='HomeTeamNextArea'>
          <div className='HomeTeamNextDiv'>
          <div className='HomeNextMatchShow'>
              <div className='HomeNextMatchShowDate'>{dataLang[sessionStorage.getItem("lang")].Date}</div>
              <div className='HomeNextMatchShowMatch'>{dataLang[sessionStorage.getItem("lang")].Match}</div>
              <div className='HomeNextMatchShowTournament'>{dataLang[sessionStorage.getItem("lang")].Tournament}</div>
          </div>

          {
            AwayNextMatchData.length !==0 ?
                           AwayNextMatchData.sort((a,b) => new Date(a.start_Time)    -  new Date(b.start_Time)).map(function(item, i){
                            return   <div key={i} className='HomeTeamMatchLine'>
                            <div className='HomeNextMatchShowDate'>{moment(item.start_Time).format("DD/MM/YY")}</div>
                                <div className='HomeNextMatchShowMatch'>
                                  <div id='teamSelected' className='HomeNextMatchShowMatchHome'>{item.home_Team_Name}</div>
                                  <div className='HomeNextMatchShowMatchSpan'>-</div>
                                  <div className='HomeNextMatchShowMatchAway'>{item.away_Team_Name}</div>
                                </div>
                                <div onMouseOver={changeBackground(item.competitionName)} className="tooltip HomeNextMatchShowTournament" ><div className="BeetweenMatchTextTool">{item.competitionName}</div></div>
                            </div>
                           })
                           :
                           ""
          }

          </div>
        </div>
        </div>
     
    </div>
  )
}
